const MONTHS = [
  "ene",
  "feb",
  "mar",
  "abr",
  "may",
  "jun",
  "jul",
  "ago",
  "sep",
  "oct",
  "nov",
  "dic",
];

const pad = (n: number) => String(n).padStart(2, "0");

// 13-oct-2026 · 10:42, in the viewer's time zone. A date that cannot be read is
// shown as the backend sent it, never guessed.
function formatDateTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return `${pad(date.getDate())}-${MONTHS[date.getMonth()]}-${date.getFullYear()} · ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function formatLastDownload(lastDownloadAt: string | null): string {
  return lastDownloadAt ? formatDateTime(lastDownloadAt) : "Nunca";
}

// «—» when the course was never uploaded, or the backend predates the field.
export function formatLastUpload(
  lastUploadAt: string | null | undefined,
): string {
  return lastUploadAt ? formatDateTime(lastUploadAt) : "—";
}
